import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Cluster'],
});

export const clusterApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllClusters: builder.query({
      query: () => `clusters/`,
      providesTags: ['Cluster'],
    }),
    findClusterById: builder.query({
      query: (id) => `clusters/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Cluster', id: result.id }] : ['Cluster'];
      },
    }),
    createCluster: builder.mutation({
      query: (cluster) => ({
        url: `clusters/`,
        method: 'POST',
        body: cluster,
      }),
      invalidatesTags: ['Cluster'],
    }),
    updateCluster: builder.mutation({
      query: (cluster) => ({
        url: `clusters/${cluster.id}/`,
        method: 'PATCH',
        body: cluster,
      }),
      invalidatesTags: ['Cluster'],
    }),
    deleteCluster: builder.mutation({
      query: (cluster) => ({
        url: `clusters/${cluster.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Cluster'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllClustersQuery,
  useFindClusterByIdQuery,
  useCreateClusterMutation,
  useUpdateClusterMutation,
  useDeleteClusterMutation,
} = clusterApi;
